import { render, staticRenderFns } from "./button.vue?vue&type=template&id=e72d2ad2&"
import script from "./button.vue?vue&type=script&lang=js&"
export * from "./button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e72d2ad2')) {
      api.createRecord('e72d2ad2', component.options)
    } else {
      api.reload('e72d2ad2', component.options)
    }
    module.hot.accept("./button.vue?vue&type=template&id=e72d2ad2&", function () {
      api.rerender('e72d2ad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/slider/src/button.vue"
export default component.exports